import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { environment } from 'src/environments/environment';
import { TealiumTrackingService } from './core/services/tealium-tracking.service';
import { UtagHelperService } from './core/services/utag-helper.service';

@Component({
  selector: 'mydocuments-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  site_language!: string;
  domDomain!: string;
  domUrl!: string;
  myEndressHausenUrl!: string;

  constructor(
    private tealium: TealiumTrackingService,
    private utagHelperService: UtagHelperService,
    private translocoService: TranslocoService
  ) {
    const body = document.getElementsByTagName('body')[0];
    const env = body.getAttribute('data-cs-env');
    console.log('Current environment =  ' + env);
    console.log('Test: No X-API-KEY Header');
    const hashParams = window.location.hash.substring(1).split('&');
    const updatedHashParams = hashParams.filter((param) => {
      let paramName = param.split('=')[0];
      paramName = paramName.startsWith('/?')
        ? paramName.substring(2)
        : paramName;
      return paramName !== 'sessionId' && paramName !== 'orderNumber';
    });
    let updatedHash =
      updatedHashParams.length > 0 ? '#' + updatedHashParams.join('&') : '';
    updatedHash = updatedHash.substring(1);
    this.site_language = this.utagHelperService.getLanguage();

    this.myEndressHausenUrl =
      origin +
      '/' +
      this.site_language +
      '/shop' +
      updatedHash +
      '#AccountOverview:';
    this.tealium.setConfig({
      account: environment.utag.account,
      profile: environment.utag.profile,
      environment: environment.utag.type,
    });
    if (environment.production) {
      const documentQuerySelectorAll = document.querySelectorAll('body')[0];

      const domDomain = JSON.parse(
        documentQuerySelectorAll.getAttribute(
          'data-product-pricing-config'
        ) as string
      ).siteUrl;

      this.domDomain = domDomain;
    } else {
      this.domUrl = '';
      this.domDomain = '';
    }
  }
  ngOnInit(): void {
    this.translocoService.setActiveLang(this.site_language);
    const ulEhBreadCrumb = document.getElementsByClassName('eh-breadcrumb');

    let ehMydocumentsOverlay: string;

    this.translocoService
      .selectTranslate('eh-mydocuments-overlay')
      .subscribe((text: string) => {
        ehMydocumentsOverlay = text;
        if (ulEhBreadCrumb[0]?.innerHTML) {
          let newBreadcrumbInnerHtml: string =
            '<li class="eh-link--list-item eh-breadcrumb--item"><a class="eh-icon icon-eh-arrow-left eh-breadcrumb--before-separator eh--hide-medium eh--hide-large" data-cs-tracking-title-normalized="';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml +=
            '"><span class="eh-breadcrumb--hidden-label">';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml += '</span></a><a href="';
          newBreadcrumbInnerHtml += this.myEndressHausenUrl;
          newBreadcrumbInnerHtml +=
            '" class="eh-link eh-breadcrumb--item-label eh-link--02 active" data-cs-tracking-title-normalized="';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml +=
            '">My Endress+Hauser</a><i class="eh-icon icon-eh-pipe eh-breadcrumb--split-separator eh--hide-medium eh--hide-large"></i><i class="eh-icon icon-eh-arrow-right eh-breadcrumb--after-separator eh--hide-small eh--hide-x-small eh-m-l-m"></i></li><li class="eh-link--list-item eh-breadcrumb--item"><a class="eh-icon icon-eh-arrow-left eh-breadcrumb--before-separator eh--hide-medium eh--hide-large" data-cs-tracking-title-normalized="';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml +=
            '"><span class="eh-breadcrumb--hidden-label">';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml +=
            '</span></a><a class="eh-link eh-breadcrumb--item-label eh-link--02 active" data-cs-tracking-title-normalized="';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml += '">';
          newBreadcrumbInnerHtml += ehMydocumentsOverlay;
          newBreadcrumbInnerHtml +=
            '</a><i class="eh-icon icon-eh-pipe eh-breadcrumb--split-separator eh--hide-medium eh--hide-large"></i><i class="eh-icon icon-eh-arrow-right eh-breadcrumb--after-separator eh--hide-small eh--hide-x-small eh-m-l-m"></i></li>';
          ulEhBreadCrumb[0].innerHTML = newBreadcrumbInnerHtml;
        }
      });
  }
}
